// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__1TiT2","visibleHandle":"Handle_visibleHandle__1jQR-","dragged":"Handle_dragged__10srz"};